import { render, staticRenderFns } from "./proof.vue?vue&type=template&id=75dd36ef&"
import script from "./proof.vue?vue&type=script&lang=js&"
export * from "./proof.vue?vue&type=script&lang=js&"
import style0 from "./proof.vue?vue&type=style&index=0&id=75dd36ef&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports